export default class TablesHelper {

	row_click_redirect(event, url) {
		let sender_element = event.target
		if(sender_element) {
			const sender_elements = this.withParentElements(sender_element)
			const sender_tags = sender_elements.map((e) => e.tagName)
			for(const tag of sender_tags) {
				if(tag && (tag === 'A' || tag === 'BUTTON')) { return }
			}

			Turbo.visit(url, { frame: '_top' })
		}
		return true
	}

	show_turbo_modal(event, url) {
		let sender_element = event.target
		if(sender_element) {
			const sender_elements = this.withParentElements(sender_element)
			const sender_tags = sender_elements.map( (element) => { element.tagName } )

			for(const tag of sender_tags) {
				if(tag && (tag === 'A' || tag === 'BUTTON')) { return }
			}

			const turboFrame = document.getElementById('turbo-modal')
			turboFrame.src = url
			turboFrame.reload()
		}
	}

	withParentElements(element) {
		let elements = [element]
		while (element.parentElement != null) {
			elements.push(element.parentElement)
			element = element.parentElement
		}
		return elements
	}

	/*
	 call with:
		if (this.parentElementHasAttribute(sender_element, 'cancelTableRowClickRedirect') {
			allow_visit = false
		}

	parentElementHasAttribute(element, attribute) {
		if (attribute in element.parentElement.dataset) {
			return true
		} else if (element.parentElement == null) {
			return false
		} else {
			return this.parentElementHasAttribute(element.parentElement, attribute)
	}
	*/
}

